import React, { Component } from 'react'
import ScrollToTop from '../../../components/ScrollToTop'
import MenuSider from '../../../components/MenuSider'
import { connect } from 'react-redux'
import IntlMessages from '../../../util/IntlMessages';
import { Collapse } from 'antd'
import './manual.css';
import axios from 'axios'
import { Constants } from '../../../Constants/Constants'

const Panel = Collapse.Panel;

class Manual extends Component {



    render() {
        return (
            <div>
                <ScrollToTop />
                <MenuSider title={<IntlMessages id="manual.title" />}>
                    <div style={{ width: "100%", padding: "5px", textAlign: "center" }}>
                        <video width="350" controls>
                            <source src="/vdo/manual.mp4" type="video/mp4"></source>              
                                    Your browser does not support the video tag.
                            </video>
                    </div>

                </MenuSider>
            </div>
        );
    }
}
const mapStatetoProps = (state) => {
    return {
        authen: state.authen,
    }
}

export default connect(mapStatetoProps)(Manual)